/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LayoutSettingsDTO } from './LayoutSettingsDTO';
import {
    LayoutSettingsDTOFromJSON,
    LayoutSettingsDTOFromJSONTyped,
    LayoutSettingsDTOToJSON,
} from './LayoutSettingsDTO';
import type { ColorsConfigDTO } from './ColorsConfigDTO';
import {
    ColorsConfigDTOFromJSON,
    ColorsConfigDTOFromJSONTyped,
    ColorsConfigDTOToJSON,
} from './ColorsConfigDTO';
import type { DashboardLayoutsDTO } from './DashboardLayoutsDTO';
import {
    DashboardLayoutsDTOFromJSON,
    DashboardLayoutsDTOFromJSONTyped,
    DashboardLayoutsDTOToJSON,
} from './DashboardLayoutsDTO';
import type { DashboardConfigDTO } from './DashboardConfigDTO';
import {
    DashboardConfigDTOFromJSON,
    DashboardConfigDTOFromJSONTyped,
    DashboardConfigDTOToJSON,
} from './DashboardConfigDTO';
import type { TableViewParamsDTO } from './TableViewParamsDTO';
import {
    TableViewParamsDTOFromJSON,
    TableViewParamsDTOFromJSONTyped,
    TableViewParamsDTOToJSON,
} from './TableViewParamsDTO';
import type { WidgetDTO } from './WidgetDTO';
import {
    WidgetDTOFromJSON,
    WidgetDTOFromJSONTyped,
    WidgetDTOToJSON,
} from './WidgetDTO';

/**
 * 
 * @export
 * @interface NewDashboardDTO
 */
export interface NewDashboardDTO {
    /**
     * 
     * @type {number}
     * @memberof NewDashboardDTO
     */
    autoComparePool?: number;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    color?: string;
    /**
     * 
     * @type {ColorsConfigDTO}
     * @memberof NewDashboardDTO
     */
    colorsConfig?: ColorsConfigDTO;
    /**
     * 
     * @type {DashboardConfigDTO}
     * @memberof NewDashboardDTO
     */
    config?: DashboardConfigDTO;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    experimentShortId?: string;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    icon?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewDashboardDTO
     */
    isDraft?: boolean;
    /**
     * 
     * @type {LayoutSettingsDTO}
     * @memberof NewDashboardDTO
     */
    layoutSettings?: LayoutSettingsDTO;
    /**
     * 
     * @type {DashboardLayoutsDTO}
     * @memberof NewDashboardDTO
     */
    layouts: DashboardLayoutsDTO;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewDashboardDTO
     */
    runIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    type: NewDashboardDTOTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewDashboardDTO
     */
    userExperimentNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    versionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof NewDashboardDTO
     */
    versionName?: string;
    /**
     * 
     * @type {TableViewParamsDTO}
     * @memberof NewDashboardDTO
     */
    viewParams?: TableViewParamsDTO;
    /**
     * 
     * @type {Array<WidgetDTO>}
     * @memberof NewDashboardDTO
     */
    widgets: Array<WidgetDTO>;
}


/**
 * @export
 */
export const NewDashboardDTOTypeEnum = {
    Compare: 'compare',
    Experiment: 'experiment',
    Report: 'report'
} as const;
export type NewDashboardDTOTypeEnum = typeof NewDashboardDTOTypeEnum[keyof typeof NewDashboardDTOTypeEnum];


/**
 * Check if a given object implements the NewDashboardDTO interface.
 */
export function instanceOfNewDashboardDTO(value: object): value is NewDashboardDTO {
    if (!('layouts' in value) || value['layouts'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('widgets' in value) || value['widgets'] === undefined) return false;
    return true;
}

export function NewDashboardDTOFromJSON(json: any): NewDashboardDTO {
    return NewDashboardDTOFromJSONTyped(json, false);
}

export function NewDashboardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDashboardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'autoComparePool': json['autoComparePool'] == null ? undefined : json['autoComparePool'],
        'color': json['color'] == null ? undefined : json['color'],
        'colorsConfig': json['colorsConfig'] == null ? undefined : ColorsConfigDTOFromJSON(json['colorsConfig']),
        'config': json['config'] == null ? undefined : DashboardConfigDTOFromJSON(json['config']),
        'experimentShortId': json['experimentShortId'] == null ? undefined : json['experimentShortId'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'layoutSettings': json['layoutSettings'] == null ? undefined : LayoutSettingsDTOFromJSON(json['layoutSettings']),
        'layouts': DashboardLayoutsDTOFromJSON(json['layouts']),
        'name': json['name'],
        'runIds': json['runIds'] == null ? undefined : json['runIds'],
        'type': json['type'],
        'userExperimentNames': json['userExperimentNames'] == null ? undefined : json['userExperimentNames'],
        'versionDescription': json['versionDescription'] == null ? undefined : json['versionDescription'],
        'versionName': json['versionName'] == null ? undefined : json['versionName'],
        'viewParams': json['viewParams'] == null ? undefined : TableViewParamsDTOFromJSON(json['viewParams']),
        'widgets': ((json['widgets'] as Array<any>).map(WidgetDTOFromJSON)),
    };
}

export function NewDashboardDTOToJSON(value?: NewDashboardDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'autoComparePool': value['autoComparePool'],
        'color': value['color'],
        'colorsConfig': ColorsConfigDTOToJSON(value['colorsConfig']),
        'config': DashboardConfigDTOToJSON(value['config']),
        'experimentShortId': value['experimentShortId'],
        'icon': value['icon'],
        'isDraft': value['isDraft'],
        'layoutSettings': LayoutSettingsDTOToJSON(value['layoutSettings']),
        'layouts': DashboardLayoutsDTOToJSON(value['layouts']),
        'name': value['name'],
        'runIds': value['runIds'],
        'type': value['type'],
        'userExperimentNames': value['userExperimentNames'],
        'versionDescription': value['versionDescription'],
        'versionName': value['versionName'],
        'viewParams': TableViewParamsDTOToJSON(value['viewParams']),
        'widgets': ((value['widgets'] as Array<any>).map(WidgetDTOToJSON)),
    };
}

